import { render, staticRenderFns } from "./detail_category.vue?vue&type=template&id=0141355a&"
import script from "./detail_category.vue?vue&type=script&lang=js&"
export * from "./detail_category.vue?vue&type=script&lang=js&"
import style0 from "./detail_category.vue?vue&type=style&index=0&id=0141355a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports